<template lang="pug">
  .vue__bank-details
    table.banking-info-table
      tbody
        tr
          th(scope="row") Имя получателя:
          td PREMIUM MANAGEMENT OU
        tr
          th(scope="row") Номер счёта:
          td EE67 2200 2210 5853 6114
        tr
          th(scope="row") Банк получателя:
          td SWEDBANK AS
        tr
          th(scope="row") Адрес банка:
          td Liivalaia 8, 15040 Tallinn, Estonia
        tr
          th(scope="row") SWIFT/BIC:
          td HABAEE2X (при оплате через интернет в некоторых банках: HABAEE2XXXX)
        tr
          th(scope="row") Пояснение:
          td
            | agreement {{agreementNumber}}
    hr
    table.banking-info-table
      tbody
        tr
          th(scope="row") Корреспондентский банк (EUR)
          td
        tr
          td SWEDBANK AS, Tallinn
          td через клиринговые системы: STEP2, EURO1 или Target
        tr
          th(scope="row") SWIFT/BIC:
          td HABAEE2X
        tr
          th(scope="row") Валюта:
          td
            strong EUR
    hr
    table.banking-info-table
      tbody
        tr
          th(scope="row") Корреспондентский банк (RUB)
          td
        tr
          td ALFA BANK, MOSCOW. ALFARUMM
          td
        tr
          td Номер корреспондентского счета в Альфа Банке:
          td СВЕДБАНК АО 301 118 101 000 000 002 47
        tr
          td
            | Номер корреспондентского счета Альфа Банк
            br
            | в Московского ГТУ Банка России:
          td 301 018 102 000 000 005 93
        tr
          td Код идентификации банка:
          td BIK – 044 525 593
        tr
          td Идентифицирующий номер плательщика:
          td INN – 772 816 8971
        tr
          th(scope="row") Валюта:
          td
            strong RUB
</template>

<script>
  export default {
    props: {
      agreementNumber: {
        type: String,
        required: true
      }
    }
  };
</script>

<style>
  .banking-info-table {
    text-align: left !important;
  }
  .banking-info-table td:first-child {
    padding-right: 42px;
  }

  .banking-info-table tr:nth-child(2n - 1) {
    background-color: #f3fbfb;
  }

  .banking-info-table td {
    width: 50%;
    padding: 4px;
  }
</style>